import { Component, OnInit , Input, Output, EventEmitter,ViewChild} from '@angular/core';
import {PaymentOptionsComponent} from "../payment-options/payment-options.component";
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-postpaid',
  templateUrl: './postpaid.component.html',
  styleUrls: ['./postpaid.component.sass']
})
export class PostpaidComponent implements OnInit {
  @ViewChild(PaymentOptionsComponent,{static: false}) paymentOptionsComp: PaymentOptionsComponent;
  constructor(private global:GlobalService) { }
  public selectBan;
  public token;

  @Input() cr;
  @Input() accountType;
  @Input() accountSubtype;
  @Input() billDueDateField;
  @Input() billDateField;
  @Input() lastPaymentAmountField;
  @Input() billBalanceField;
  @Input() currentList;
  @Input() paperless;
  public type="postpaid";
  
  @Output() updateinitializeData = new EventEmitter();

  ngOnInit() {
    this.token=sessionStorage.getItem("token");
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
  }

  initializeData(){
    this.updateinitializeData.emit();
  }
  updateCredit(selectBan,billBalanceField,type){
    if(this.global.validateSession()===true){
      this.selectBan=selectBan;
      this.billBalanceField=billBalanceField;
      this.type=type;
      this.paymentOptionsComp.updateCredit(this.selectBan,billBalanceField,type);
    }
  }
}